import { Link } from "react-router-dom";
import { CONTACT, BRAND } from "../data";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-wine text-blush">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="font-sans text-[11px] tracking-[0.35em] uppercase text-rose mb-8">
              {BRAND.tagline}
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-2xl text-white">
              Let's build something <span className="italic font-display">meaningful.</span>
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-3 mt-10 rounded-full bg-white text-wine px-8 py-4 font-sans text-[12px] tracking-[0.18em] uppercase transition-colors duration-300 hover:bg-rose hover:text-white"
            >
              Work With Me
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-10 content-start">
            <div>
              <p className="font-sans text-[11px] tracking-[0.3em] uppercase text-rose mb-5">Contact</p>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="block font-sans text-sm text-blush/80 hover:text-white mb-3 break-all">
                {CONTACT.email}
              </a>
              <a href={`tel:${CONTACT.phoneHref}`} data-testid="footer-phone" className="block font-sans text-sm text-blush/80 hover:text-white mb-3">
                {CONTACT.phone}
              </a>
              <a href={CONTACT.tiktokUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok" className="block font-sans text-sm text-blush/80 hover:text-white mb-3">
                TikTok {CONTACT.tiktok}
              </a>
              {CONTACT.linkedinUrl && (
                <a href={CONTACT.linkedinUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="block font-sans text-sm text-blush/80 hover:text-white mb-3">
                  LinkedIn
                </a>
              )}
              <p className="font-sans text-sm text-blush/60">{CONTACT.location}</p>
            </div>
            <div>
              <p className="font-sans text-[11px] tracking-[0.3em] uppercase text-rose mb-5">Explore</p>
              {[
                ["About", "/about"],
                ["Services", "/services"],
                ["Work With Me", "/work-with-me"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <Link key={to} to={to} className="block font-sans text-sm text-blush/80 hover:text-white mb-3">
                  {label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/15 flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-sans text-xs text-blush/50">© {new Date().getFullYear()} Rooted Strategy with Roisin Doyle. All rights reserved.</p>
          <p className="font-sans text-xs text-blush/50">Content Strategy · Brand · Community · Ireland</p>
        </div>
      </div>
    </footer>
  );
};
